import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { environment } from '../../../environments/environment';
import { ReactComponent as LinkedInLogo } from '../../assets/images/icons/linkedin.svg';
import { useKirbyCheckGroups, useKirbyInfoGeneral } from '../../hooks/useKirbyData';
import * as Styled from './Footer.styles';
import { AuthContext } from '../../contexts/auth.context';
import { useTranslation, Trans } from 'react-i18next';

const Footer: React.FC = () => {
  const { data: checkGroups } = useKirbyCheckGroups();
  const { data: info } = useKirbyInfoGeneral();
  const { auth } = useContext(AuthContext);
  const userIsLoggedOut = auth === null;
  const { t } = useTranslation();

  return (
    <Styled.Footer>
      <Styled.FooterWrapper>
        <Styled.SmallWrapper>
          <Styled.AdjustedLogo />
        </Styled.SmallWrapper>
        <Styled.Line />
        <Styled.SmallWrapper>
          <Styled.Topics>
            <Styled.Col>
              <h5>
                <Trans i18nKey={'footer.checks'} />
              </h5>
              {(checkGroups ?? []).map((group, i) => (
                <React.Fragment key={group.name}>
                  {i !== 0 && <br />}
                  {userIsLoggedOut ? (
                    environment.language ? (
                      <a
                        href={`${environment.kirbyBaseUrl}/${t('links.language')}#${group.slug}`}
                        target='_blank'
                        rel='noreferrer'>
                        {group.name}
                      </a>
                    ) : (
                      <a href={`${environment.kirbyBaseUrl}#${group.slug}`} target='_blank' rel='noreferrer'>
                        {group.name}
                      </a>
                    )
                  ) : (
                    <NavLink to={{ pathname: '/', hash: group.slug }}>{group.name}</NavLink>
                  )}
                </React.Fragment>
              ))}
            </Styled.Col>
            <Styled.Col>
              <h5>
                <Trans i18nKey={'footer.legal'} />
              </h5>
              {environment.language ? (
                <a href={`${environment.kirbyBaseUrl}/${t('links.legal')}`} target='_blank' rel='noopener noreferrer'>
                  <Trans i18nKey={'footer.impressum'} />
                </a>
              ) : (
                <a href={`${environment.kirbyBaseUrl}/legal`} target='_blank' rel='noopener noreferrer'>
                  <Trans i18nKey={'footer.impressum'} />
                </a>
              )}
              <br />
              <a href={t('links.dataProtection')} target='_blank' rel='noopener noreferrer'>
                <Trans i18nKey={'footer.dataProtection'} />
              </a>
              <br />
              {environment.language ? (
                <a href={`${environment.kirbyBaseUrl}/${t('links.terms')}`} target='_blank' rel='noopener noreferrer'>
                  <Trans i18nKey={'footer.terms'} />
                </a>
              ) : (
                <a href={`${environment.kirbyBaseUrl}/terms-of-use/free`} target='_blank' rel='noopener noreferrer'>
                  <Trans i18nKey={'footer.terms'} />
                </a>
              )}
            </Styled.Col>
            {info && (
              <Styled.Col $type='aeb'>
                <h5>
                  <a href='https://www.aeb.com/de-de/' target='_blank' rel='noopener noreferrer'>
                    {info.title}
                  </a>
                </h5>
                <p>
                  {info.address.street}
                  <br />
                  {info.address.city}
                  <br />
                  {info.address.country}
                </p>
                <p>
                  {environment.language ? t('links.email') : 'E-Mail'}: <a href={`mailto:${info.email}`}>{info.email}</a>
                </p>
                <p>
                  <Styled.SocialLink href={info.social.linkedin} target='_blank' rel='noreferrer'>
                    <LinkedInLogo />
                  </Styled.SocialLink>
                </p>
              </Styled.Col>
            )}
          </Styled.Topics>
        </Styled.SmallWrapper>
      </Styled.FooterWrapper>
    </Styled.Footer>
  );
};

export default Footer;
